import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OverlayType } from '../../types/enum';

export const OverlayActions = createActionGroup({
  source: 'Overlay',
  events: {
    'Show Overlay': props<{ value: OverlayType }>(),
    'Close Overlay': emptyProps(),
    'Close Application': emptyProps(),
  },
});
